export const WIDGET_STYLES = `
:host {
  display: block;
  font-family: var(--wall-font);
  color: var(--wall-bg-fg);
  background: var(--wall-bg);
  --wall-radius: 0.5rem;
}
* , *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
:host([data-mode="dark"]) { color-scheme: dark; }
:focus-visible {
  outline: 2px solid var(--wall-accent);
  outline-offset: 2px;
}
a { color: var(--wall-accent); text-decoration: underline; }
.mbn-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem;
  border-bottom: 1px solid var(--wall-border);
}
.mbn-brand { display: flex; flex-direction: column; align-items: center; gap: 0.375rem; }
.mbn-brand-name { font-weight: 600; font-size: 0.9375rem; text-align: center; }
.mbn-logo { height: 2rem; width: auto; }
.mbn-summary { display: flex; align-items: center; gap: 0.5rem; flex-wrap: wrap; }
.mbn-stars { color: var(--wall-accent); letter-spacing: 0.1em; font-size: 1rem; }
.mbn-rating-value { font-weight: 600; font-size: 1rem; }
.mbn-rating-count { color: var(--wall-muted); font-size: 0.875rem; }
.mbn-cta {
  font-size: 0.875rem;
  font-weight: 500;
}
.mbn-review {
  background: var(--wall-surface);
  color: var(--wall-fg);
  border: var(--wall-card-border-width, 1px) solid var(--wall-card-border-color, var(--wall-border));
  border-radius: var(--wall-card-radius, var(--wall-radius));
  box-shadow: var(--wall-card-shadow, none);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.mbn-review-head { display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; }
.mbn-review-date { color: var(--wall-muted); font-size: 0.8125rem; }
.mbn-review-body { font-size: 0.9375rem; line-height: 1.5; }
.mbn-review-author { color: var(--wall-muted); font-size: 0.8125rem; font-style: normal; }
.mbn-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  padding: 1rem;
}
.mbn-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
}
.mbn-carousel {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
}
.mbn-slides { display: grid; min-height: 8rem; }
.mbn-slides > .mbn-review { grid-area: 1 / 1; }
.mbn-slides > .mbn-review[aria-hidden="true"] { visibility: hidden; }
.mbn-slides > .mbn-review > .mbn-review-author { margin-top: auto; }
.mbn-slides[data-transition="slide"] > .mbn-review[aria-hidden="false"] { animation: mbn-slide-in var(--wall-carousel-duration, 1200ms) cubic-bezier(0.22, 1, 0.36, 1) both; }
.mbn-slides[data-transition="fade"] > .mbn-review[aria-hidden="false"] { animation: mbn-fade-in var(--wall-carousel-duration, 1200ms) ease-out both; }
.mbn-slides[data-transition="zoom"] > .mbn-review[aria-hidden="false"] { animation: mbn-zoom-in var(--wall-carousel-duration, 1200ms) cubic-bezier(0.22, 1, 0.36, 1) both; }
@keyframes mbn-slide-in { from { opacity: 0; transform: translateX(1.5rem); } to { opacity: 1; transform: translateX(0); } }
@keyframes mbn-fade-in { from { opacity: 0; } to { opacity: 1; } }
@keyframes mbn-zoom-in { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
@media (prefers-reduced-motion: reduce) {
  .mbn-slides > .mbn-review[aria-hidden="false"] { animation: none !important; }
}
.mbn-controls { display: flex; align-items: center; justify-content: center; gap: 0.5rem; }
.mbn-controls button {
  min-width: 2.25rem;
  background: transparent;
  border: 1px solid var(--wall-border);
  border-radius: var(--wall-radius);
  color: var(--wall-fg);
  font: inherit;
  font-size: 0.875rem;
  cursor: pointer;
  padding: 0.25rem 0.625rem;
  line-height: 1;
}
.mbn-controls button:hover { border-color: var(--wall-accent); }
.mbn-footer { padding: 0.5rem 1rem; text-align: right; }
.mbn-footer-link { font-size: 0.6875rem; opacity: 0.7; }
.mbn-empty {
  padding: 1.5rem;
  text-align: center;
  color: var(--wall-muted);
  font-size: 0.9375rem;
}
@media (max-width: 480px) {
  .mbn-grid { grid-template-columns: 1fr; }
}
`;
